import Equipment from './equipment';

export default class ArmourSkin extends Equipment {}
